import React from 'react';
import { connect } from 'react-redux'
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core';
import goTo from '../../../../actions/goTo';
import GeneralButton from '../../../../components/Common/AllButton/AllButton';
import { createTagPayload } from '../../../../../utils/tagHelpers';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    container: {
        marginTop: 10,
        marginRight: 10,
        height: 310,
        width: 206,
        position: 'relative',
        borderRadius: 4,
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)',
        backgroundColor: '#fff',      
        '&:last-child': {
            marginRight: 0
        },
        '&:nth-child(6)': {
            marginRight: 0
        },
        
    },
    overlay: {
        position: 'absolute',
        width: 'auto',
        height: 'auto',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0
    },
    title: {
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
            textDecorationColor: 'ffffff'
        },
        marginTop: 16,
        fontFamily: 'Rubik',
        fontSize: 18,
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#21212d',
    },
    subtitle: {
        marginTop: 4,
        fontFamily: 'Rubik',
        fontSize: 14,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#a3a3a3',
    },
    img: {
        marginTop: 36,
        display: 'flex',
        marginRight: 'auto',
        marginLeft: 'auto',
        width: 134,
        height: 134
    },
    subsribe: {
        marginTop: 16,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    subsribeButtomContainer: {
        width: 130,
        height: 38,
        backgroundColor: 'transparent',
        border: 'solid 2px #21212d',
        color: '#21212d',
        '&:hover': {
            background: '#21212d',
            color: '#fff',
        },
    },
    subsribeButtomText: {
        marginTop: 2,
        fontSize: 14,
        lineHeight: 2,
        letterSpacing: 1.5,
    },
    unsubsribeButtomContainer: {
        width: 130,
        height: 38,
        backgroundColor: '#21212d',
        border: 'solid 2px #21212d',
        color: '#fff',
        '&:hover': {
            background: 'transparent',
            color: '#21212d',
        },
    },
});

const checkIfSubscribed = (tag, userData) => {    
    if(userData.subscribedTags && userData.subscribedTags.length && tag){
        return userData.subscribedTags.some(t => (t.tag || "").toLowerCase() === tag.toLowerCase())
    }
    return false
}

const TrendingHashtag = (props) => {
    const {classes, hashtag, dispatch, userData, subscribe, t} = props
    const tag = hashtag.meta.key
    const isSubsribed = checkIfSubscribed(tag, userData)

    const openHashtagView = () => {
        goTo(hashtag.title, dispatch)();
    }
    const onClickGeneral = () => {
        if(isSubsribed) {
            openHashtagView()
            return
        }
        subscribe(createTagPayload(tag, null, 'user_tag'), openHashtagView)
    }
    const renderSubscribeButton = () => {
        const title = isSubsribed ? t('VIEW') : t('SUBSCRIBE')
        const containerStyle = isSubsribed ? classes.unsubsribeButtomContainer : classes.subsribeButtomContainer
        return <GeneralButton onClick={onClickGeneral} containerStyle={containerStyle} textStyle={classes.subsribeButtomText} title={title} />
    }
        return (
            <div data-intrcm-id="TrendingHashtag_0hgyrvix" className={classes.container}>
              <img alt="img" className={classes.img} src={hashtag.backgroundImage}></img>
              <div data-intrcm-id="TrendingHashtag_cz0kxybz" onClick={openHashtagView} className={classes.title}>{hashtag.title}</div>
              <div data-intrcm-id="TrendingHashtag_d3bqude9" className={classes.subtitle}>{hashtag.items} items</div>
              <div data-intrcm-id="TrendingHashtag_q99va3yb" className={classes.subsribe}>{renderSubscribeButton()}</div>
          </div>
        )
}

const mapStateToProps = (state) => ({
    userData: state.userData
})


const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles, {withTheme: true}),
    withTranslation('groupDrawerTranslate'),
    connect(mapStateToProps, mapDispatchToProps))(TrendingHashtag);
